import { Flex } from 'mds-web-ui'
import { Link } from 'gatsby'
import React from 'react'

import { FlowLogo } from './FlowLogo'

export const FlowGalleryHeader = ({ children, ...props }) => {
  return (
    <Flex
      as="header"
      justifyContent="space-between"
      alignItems="flex-start"
      gap={3}
      {...props}
    >
      <Link to="/flow/gallery">
        <FlowLogo />
      </Link>

      {children}
    </Flex>
  )
}
